// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__1ssTo","Label":"Checkbox_Label__2cbQd","InputElement":"Checkbox_InputElement__1LDRd","Invalid":"Checkbox_Invalid__1JRSI"};